import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { LogoModule } from '@pt/components/logo';

import { ControlsComponent } from './components/controls/controls.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';

@Component({
  selector: 'aa-header, [aaHeader]',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LogoModule, ControlsComponent, UserProfileComponent],
})
export class HeaderComponent {
  isShadowVisible = input<boolean, unknown>(false, { transform: booleanAttribute });
}
